export default {
  title: 'Lisäkkeet',
  master_title: 'Brändi-tila - Lisäkkeet',
  products_creation_disabled:
    'Koska {{integration}}-integraatio on aktiivinen, uusien tuotteiden luominen ei ole sallittua. Jos haluat muuttaa valikkoa, tee muutokset {{integration}}-palvelussa ja synkronoi valikko.',
  labels: {
    select_all: 'Valitse kaikki',
  },
  buttons: {
    add_modifier: 'Lisää lisäke',
    delete_selected: 'Poista valitut',
    refresh: 'Päivitä',
  },
  toasts: {
    failed_to_load_data: 'Tietojen lataaminen epäonnistui',
  },
};
